export default "__VITE_ASSET__e4u2PwAm__"